module.exports = __webpack_public_path__ + "img/person-skiing.323f65ed.svg";